import * as React from 'react';
import { DndContext, createDndContext } from './DndContext';
/**
 * A React component that provides the React-DnD context
 */
export const DndProvider = ({ children, ...props }) => {
    const contextValue = 'manager' in props
        ? { dragDropManager: props.manager }
        : createDndContext(props.backend, props.context, props.debugMode);
    return (React.createElement(DndContext.Provider, { value: contextValue }, children));
};
